import { Components, Theme } from "@mui/material";
import { hexToRGBA } from "@utils";

export const muiTableFooterTheme = (
  theme: Theme,
): Pick<Components<Omit<Theme, "components">>, "MuiTableFooter"> => ({
  MuiTableFooter: {
    styleOverrides: {
      root: {
        "& .MuiTableRow-root": {
          backgroundColor: hexToRGBA(theme.palette.background.default, 0.25),
          borderBottomWidth: "1px",
        },
        "& .MuiTableCell-root": {
          fontWeight: 500,
          fontSize: "13px",
          color: theme.palette.text.primary,
          padding: "15px 16px",
        },
      },
    },
  },
});
